import { html } from "../../render";
import { cn, spreadAttrs } from "../../utils";
import { LpLoader } from "../loader";
const loadingOverlayManagedAttrs = ["data-lp-component", "class"];
export function LpLoadingOverlay({ label = "Loading...", description, loaderLabel, loaderSize = "lg", className, attributes, } = {}) {
    const statusLabel = typeof label === "string" ? label : "Loading";
    return html `
        <div
            data-lp-component="LoadingOverlay"
            class="${cn("lp-loading-overlay", className, attributes?.class)}"
            role="status"
            aria-live="polite"
            ${spreadAttrs(attributes, { omit: loadingOverlayManagedAttrs })}
        >
            <div class="lp-loading-overlay_content">
                ${LpLoader({ size: loaderSize, label: loaderLabel || statusLabel })}
                ${label ? html `<span class="lp-loading-overlay_label">${label}</span>` : ""}
                ${description ? html `<span class="lp-loading-overlay_description">${description}</span>` : ""}
            </div>
        </div>
    `;
}
